// 企业    活动
import axios from "../../../../untils/request.js";

//企业车险商机-智能匹配列表
export async function carSafeInfoForCompany(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/sys/carSafe/carSafeInfoForCompany",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//企业车险商机-已分配列表
export async function carSafeInfoForCompanyAllocate(
  data,
  currentPage,
  pageSize
) {
  const res = await axios({
    method: "post",
    url: "/sys/carSafe/carSafeInfoForCompanyAllocate",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
// ----------------------  下载车险商机列表数据 -----------------
export async function downloadCompanyCarSafeData(data) {
  const res = await axios({
    method: "post",
    url: "/sys/carSafe/downloadCompanyCarSafeData",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
    responseType: "blob",
  });
  return res.data;
}

//企业车险商机-转发列表
export async function carSafeInfoForCompanyForward(
  data,
  currentPage,
  pageSize
) {
  const res = await axios({
    method: "post",
    url: "/sys/carSafe/carSafeInfoForCompanyForward",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//企业车险商机-已购列表
export async function carSafeInfoForCompanyPaid(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/sys/carSafe/carSafeInfoForCompanyPaid",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//已分配/已购列表 车险商机转发
export async function carSafeInfoForward(data) {
  const res = await axios({
    method: "post",
    url: "/sys/carSafe/carSafeInfoForward",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//获取道具剩余可用数量 Copy
export async function getPropCount(data) {
  const res = await axios({
    method: "post",
    url: "/info/company/getPropCount",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//使用信息卡购买车险商机
export async function buyCarSafeInfoByInfoCard(data) {
  const res = await axios({
    method: "post",
    url: "/sys/carSafe/buyCarSafeInfoByInfoCard",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}


//获取相关道具价格
export async function getSysPropPrice(data) {
  const res = await axios({
    method: "post",
    url: "/sys/getSysPropPrice",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//道具购买价格计算
export async function calculateBuyPropPrice(data) {
  const res = await axios({
    method: "post",
    url: "/sys/calculateBuyPropPrice",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//创建订单支付接口 - 人才信用卡，商机信息卡支付
export async function pay(data) {
  const res = await axios({
    method: "post",
    url: "/info/pay",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

//判断能否进行精英沟通--true 可沟通->跳转会话列表， false 不能沟通->弹出购买页面
export async function judgeCanCommunicateElite(data) {
  const res = await axios({
    method: "post",
    url: "/global/judgeCanCommunicateElite",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//判断是否可免费查看信用评价 true-->免费 false-->付费
export async function judgeCanFreeViewCreditEvaluation(data) {
  const res = await axios({
    method: "post",
    url: "/info/user/judgeCanFreeViewCreditEvaluation",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
//获取当前招聘者已发布职位信息
export async function getPublishPositionInfoList(data) {
  const res = await axios({
    method: "post",
    url: "/global/company/getPublishPositionInfoList",
    intercept: 1,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}